export const apiKey = "AIzaSyBR3FOauSfQc4jyFfEyCxRw-ilAKTIU3cw"